@if (taskView$ | async) {
  <ts-table-grouped
    [columnDefs]="columnDefs"
    [rowData]="rowData"
    [data]="routeData"
    [treeData]="true"
    [getDataPath]="getDataPath"
    [enableCellChangeFlash]="true"
    [gridOptions]="gridOptions"
    [hasCheckboxColumn]="true"
    [clientSorting]="false"
    [autoHeight]="false"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [tooltipShowDelay]="0"
    (sortChanged)="onSortChanged($event)"
    (rowDragEnd)="onRowDragEnd($event)"
    (rowDataUpdated)="onRowDataUpdated($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (gridReady)="onGridReady($event)"
    (onColumnMove)="onColumnMoved($event)"
    (cellEditingStopped)="onCellEditingStopped($event)"
    (cellEditingStarted)="onStartEditingCell($event)"
    (columnResized)="onColumnResized($event)"
  ></ts-table-grouped>
}
